(function () {
  var CFG = window.VORO_INTEREST || {};
  var API = (CFG.api || 'https://ship.voromotors.cloud').replace(/\/+$/, '') + '/api/public/interest';
  var MIN_VIEWS = Math.max(1, parseInt(CFG.minViews, 10) || 10);
  var MIN_CARTS = Math.max(1, parseInt(CFG.minCarts, 10) || 2);
  var ID_RE = /^\d{6,20}$/;

  var counts = {};
  var known = [];
  var done = typeof WeakSet === 'function' ? new WeakSet() : null;
  var tracked = {};

  function send(productId, kind) {
    try {
      var body = JSON.stringify({ productId: String(productId), kind: kind });
      var blob = new Blob([body], { type: 'text/plain' });
      if (navigator.sendBeacon && navigator.sendBeacon(API + '/event', blob)) return;
      fetch(API + '/event', { method: 'POST', body: body, keepalive: true, mode: 'no-cors',
        headers: { 'Content-Type': 'text/plain' } }).catch(function () {});
    } catch (e) {   }
  }

  document.addEventListener('voro-cart:itemAdd', function (e) {
    var d = e && e.detail;
    var items = d && d.items ? d.items : (d ? [d] : []);
    items.forEach(function (it) {
      var pid = it && it.product_id != null ? String(it.product_id) : '';
      if (pid && known.indexOf(pid) !== -1) send(pid, 'cart');
    });
  });
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[action*="/cart/add"]')) return;
    var host = f.closest('[data-voro-interest-scope]');
    var pid = host && host.getAttribute('data-voro-interest-scope');
    if (pid && known.indexOf(pid) !== -1) send(pid, 'cart');
  }, true);

  var EYE = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12z"/><circle cx="12" cy="12" r="3"/></svg>';
  var BAG = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 7h12l-1 13H7L6 7z"/><path d="M9 7a3 3 0 0 1 6 0"/></svg>';

  var FIRE = '<span class="voro-vi-fire" aria-hidden="true">&#128293;</span>';

  function plural(n, one, many) { return n + ' ' + (n === 1 ? one : many); }

  function lines(c, mode) {
    var out = [];
    var carts = c && c.carts >= MIN_CARTS ? c.carts : 0;
    var views = c && c.views >= MIN_VIEWS ? c.views : 0;
    if (mode === 'card') {
      if (carts) out.push([FIRE, 'Hot &middot; ' + carts + ' added to cart this week']);
      else if (views) out.push([EYE, plural(views, 'view', 'views') + ' this week']);
      return out;
    }
    if (carts) out.push([FIRE, 'Hot: ' + plural(carts, 'shopper', 'shoppers') + ' added this unit to their cart this week']);
    if (views) out.push([EYE, plural(views, 'person', 'people') + ' viewed this unit this week']);
    return out;
  }

  function paintOne(el) {
    var id = el.getAttribute('data-voro-interest');
    if (!counts[id]) return false;
    if (done) done.add(el); else el.setAttribute('data-vi-done', '');
    var mode = el.getAttribute('data-voro-interest-mode') || 'card';
    var target = el.querySelector('[data-vi-live]') || el;
    var scope = mode === 'card' ? (el.closest('.card--default') || el.parentNode) : el;
    var c = counts[id];
    if (scope && scope.querySelector('[data-vi-static-hot]')) c = { views: c.views, carts: 0 };
    var ls = lines(c, mode);
    if (!ls.length) return true;
    target.innerHTML = ls.map(function (l) {
      return '<span class="voro-vi-line">' + l[0] + '<span>' + l[1] + '</span></span>';
    }).join('');
    target.hidden = false;
    el.hidden = false;
    requestAnimationFrame(function () { el.classList.add('is-in'); });
    return true;
  }

  function isDone(el) { return done ? done.has(el) : el.hasAttribute('data-vi-done'); }

  var inflight = {};
  function scan() {
    var fresh = [].slice.call(document.querySelectorAll('[data-voro-interest]')).filter(function (el) {
      return !isDone(el) && ID_RE.test(String(el.getAttribute('data-voro-interest') || ''));
    });
    if (!fresh.length) return;
    var need = [];
    fresh.forEach(function (el) {
      var id = el.getAttribute('data-voro-interest');
      if (known.indexOf(id) === -1) known.push(id);
      if (el.hasAttribute('data-voro-interest-track') && !tracked[id]) { tracked[id] = true; send(id, 'view'); }
      if (!paintOne(el) && !counts[id] && !inflight[id] && need.indexOf(id) === -1) need.push(id);
    });
    if (!need.length) return;
    need.forEach(function (id) { inflight[id] = true; });
    fetch(API + '?ids=' + need.join(','), { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        need.forEach(function (id) { delete inflight[id]; });
        if (!d || !d.counts) return;
        need.forEach(function (id) { if (d.counts[id]) counts[id] = d.counts[id]; });
        [].slice.call(document.querySelectorAll('[data-voro-interest]')).forEach(function (el) {
          if (!isDone(el)) paintOne(el);
        });
        buildRail();
      })
      .catch(function () { need.forEach(function (id) { delete inflight[id]; }); });
  }

  function esc(v) { return String(v == null ? '' : v).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function buildRail() {
    var rail = document.querySelector('[data-vi-hot-rail]');
    var track = rail && rail.querySelector('[data-vi-hot-track]');
    if (!track) return;
    var seen = {}, hot = [];
    [].slice.call(document.querySelectorAll('.voro-vi-chip[data-vi-url]')).forEach(function (el) {
      var id = el.getAttribute('data-voro-interest'), c = counts[id];
      if (seen[id]) return;
      var live = c && c.carts >= MIN_CARTS ? c.carts : 0;
      var hist = parseInt(el.getAttribute('data-vi-hist-carts'), 10) || 0;
      if (hist < MIN_CARTS) hist = 0;
      if (!live && !hist) return;
      seen[id] = true;
      hot.push({ c: live || hist, w: live ? 'this week' : 'since ' + (el.getAttribute('data-vi-hist-since') || 'listing'),
        url: el.getAttribute('data-vi-url'), t: el.getAttribute('data-vi-title'),
        img: el.getAttribute('data-vi-img'), p: el.getAttribute('data-vi-price') });
    });
    if (!hot.length) return;
    hot.sort(function (a, b) { return b.c - a.c; });
    track.innerHTML = hot.map(function (h) {
      return '<a class="voro-hot__item" href="' + esc(h.url) + '">' +
        (h.img ? '<img src="' + esc(h.img) + '" alt="" loading="lazy" width="360" height="360">' : '') +
        '<span class="voro-hot__t">' + esc(h.t) + '</span>' +
        '<span class="voro-hot__p">' + esc(h.p) + '</span>' +
        '<span class="voro-hot__c">&#128293; ' + h.c + ' add-to-carts ' + esc(h.w) + '</span></a>';
    }).join('');
    rail.hidden = false;
  }

  scan();
  buildRail();

  if (window.MutationObserver && document.body) {
    var t = null;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType === 1 && (n.hasAttribute('data-voro-interest') || (n.querySelector && n.querySelector('[data-voro-interest]')))) {
            clearTimeout(t); t = setTimeout(scan, 150);
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
